import { Box, Flex } from '@chakra-ui/react';
import { useReviewCreationData, useSelfFormFillingScoreSettings } from 'reducers/reviewCreationSlice';

import { REVIEW_PROVIDER_TYPES } from 'constants/ProjectConstants';

import { ListWarning } from 'uiToolkitV1/ListWarning';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { useGetFormFillings } from '../../../Hooks/dataHooks/formFillingsDataHooks';
import { useTemplateMetadata } from '../../../Hooks/dataHooks/shareResultsDataHooks';

export const ScoreVisibilitySettings = ({ feedbackFormId }) => {
  const { reviewCycleId } = useReviewCreationData();
  const selfTemplateMetadata = useTemplateMetadata({
    reviewCycleId,
    feedbackFormId,
    providerType: REVIEW_PROVIDER_TYPES.SELF,
  });
  const hasGoalQuestions = selfTemplateMetadata?.template?.templateSetting?.overallRatingDistribution?.PERFORMANCE > 0;
  const hasCompetencyQuestions =
    selfTemplateMetadata?.template?.templateSetting?.overallRatingDistribution?.POTENTIAL > 0;

  const selfFormFillingScoreSettings = useSelfFormFillingScoreSettings({ feedbackFormId });
  // just to trigger form filling step data fetch
  useGetFormFillings({ reviewCycleId });

  const applicableCategories = [];

  if (hasGoalQuestions && selfFormFillingScoreSettings?.isShowGoalRating) {
    applicableCategories.push('Overall Goals Score');
  }
  if (hasCompetencyQuestions && selfFormFillingScoreSettings?.isShowCompetencyRating) {
    applicableCategories.push('Overall Competency Score');
  }
  if (selfFormFillingScoreSettings?.isShowOverallRating) {
    applicableCategories.push('Overall Score');
  }

  const infoTextApplicableCategories = applicableCategories.length > 0 ? applicableCategories.join(', ') : 'None';

  const infoText1 = (
    <Box>
      <TextBodyMedium>
        The Self Reviewer will be able to view the following scores post publish: {infoTextApplicableCategories}.
      </TextBodyMedium>
      <TextBodyMedium>
        This is linked to the options chosen in the section &rsquo;Form Filling Experience&rsquo;. To alter the same
        please go back to review the options chosen by you.
      </TextBodyMedium>
    </Box>
  );

  return (
    <Flex flexDir="column" gap={3}>
      <Flex alignItems="center" gap={2}>
        <TextBodyMedium>Granularity of scores self can see in the shared report card</TextBodyMedium>
      </Flex>

      <ListWarning mt={2} warningText={infoText1} />
    </Flex>
  );
};
